import React, { createContext, useContext, useState, useCallback } from "react";
import { isEqual, isFunction } from "lodash";

const CityUIContext = createContext();

export function useCityUIContext() {
  return useContext(CityUIContext);
}

export const CityUIConsumer = CityUIContext.Consumer;

export function CityUIProvider({
  cityUIEvents,
  children,
  queryParams,
  setQueryParamsBase,
  ids,
  setIds,
}) {
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const value = {
    queryParams,
    setQueryParamsBase,
    ids,
    setIds,
    setQueryParams,
    openReceiptDialog: cityUIEvents.openReceiptDialog,
    openDeleteDialog: cityUIEvents.openDeleteDialog,
    openEditDialog: cityUIEvents.openEditDialog,
  };

  return (
    <CityUIContext.Provider value={value}>{children}</CityUIContext.Provider>
  );
}
